import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isMeetingOnCalendarSharedWithMe } from 'owa-calendar-event-capabilities';
import { LocalCalendarEntry, LinkedCalendarEntry } from 'owa-graph-schema';
import { getCalendarEntryByFolderId } from 'owa-calendar-cache';
import { isConnectedAccount } from 'owa-accounts-store';
import { getUserConfigurationForUser } from 'owa-session-store';

/**
 * Returns the owner of an calendar item
 * @param item The calendar item
 */
export default function getCalendarOwnerFromItem(item: CalendarEvent): EmailAddressWrapper {
    if (item.ParentFolderId?.Id) {
        if (isMeetingOnCalendarSharedWithMe(item)) {
            let calendarEntry = getCalendarEntryByFolderId(item.ParentFolderId.Id);
            if (calendarEntry) {
                let localCalendarEntry: LocalCalendarEntry = calendarEntry as LocalCalendarEntry;
                if (
                    localCalendarEntry.SharedOwnerEmailAddress &&
                    localCalendarEntry.SharedOwnerName
                ) {
                    return {
                        EmailAddress: localCalendarEntry.SharedOwnerEmailAddress,
                        Name: localCalendarEntry.SharedOwnerName,
                    };
                }

                let linkedCalendarEntry: LinkedCalendarEntry = calendarEntry as LinkedCalendarEntry;
                if (linkedCalendarEntry.OwnerEmailAddress && linkedCalendarEntry.OwnerName) {
                    return {
                        EmailAddress: linkedCalendarEntry.OwnerEmailAddress,
                        Name: linkedCalendarEntry.OwnerName,
                    };
                }
            }
        }

        if (
            item.ParentFolderId.mailboxInfo &&
            isConnectedAccount(item.ParentFolderId.mailboxInfo.userIdentity)
        ) {
            const userConfigurationForUser = getUserConfigurationForUser(
                item.ParentFolderId.mailboxInfo.userIdentity
            );

            let displayName = null;
            if (userConfigurationForUser?.SessionSettings) {
                displayName = userConfigurationForUser.SessionSettings.UserDisplayName;
            }

            return {
                EmailAddress: item.ParentFolderId.mailboxInfo.userIdentity,
                Name: displayName,
            };
        }
    }

    let sessionSettings = getUserConfiguration().SessionSettings;
    return {
        EmailAddress: sessionSettings.UserEmailAddress,
        Name: sessionSettings.UserDisplayName,
    };
}
